/* eslint-disable indent */
import Axios from 'axios'
import Promise from 'bluebird'
import store from './store'
import qs from 'qs'

Promise.config({
  warnings: false,
  longStackTraces: false,
  cancellation: true
})

const getClient = () => {
  const options = {
    baseURL: process.env.VUE_APP_BACKEND_URL,
    withCredentials: true
  }

  // noinspection UnnecessaryLocalVariableJS
  const client = Axios.create(options)

  /*
  // Add a request interceptor
  client.interceptors.request.use(
      requestConfig => requestConfig,
      (requestError) => {
          return Promise.reject(requestError);
      },
  );

  // Add a response interceptor
  client.interceptors.response.use(
      response => response,
      (error) => {
          return Promise.reject(error);
      },
  );
  */

  return client
}

const client = getClient()

class Api {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
  }

  // noinspection JSUnusedGlobalSymbols
  newClient () {
    this.client = getClient()
    return this
  }

  getClient () {
    this.client = this.client || client
    return this.client
  }

  any (type, url, params = {}) {
    const filteredParams = {}

    for (const key in params) {
      // eslint-disable-next-line no-prototype-builtins
      if (params.hasOwnProperty(key) && !['', false].includes(params[key])) {
        filteredParams[key] = params[key]
      }
    }

    /**
     * Дописываем ко всем запросам языковую версию...
     */
    filteredParams.language = store.state.locale

    return this.request(Object.assign({
      url: url,
      method: type,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }, ((type === 'post' || type === 'put' || type === 'patch') ? {
      data: qs.stringify(filteredParams)
    } : {
      params: filteredParams
    })))
  }

  get (url, params = {}) {
    return this.any('get', url, params)
  }

  post (url, params = {}) {
    return this.any('post', url, params)
  }

  request (configRequest) {
    return new Promise((resolve, reject, onCancel) => {
      const cancelSource = Axios.CancelToken.source()
      // eslint-disable-next-line no-prototype-builtins
      const cancelToken = configRequest.hasOwnProperty('cancelToken') ? configRequest.cancelToken : cancelSource.token
      const requestConfig = { ...configRequest, ...{ cancelToken } }

      onCancel(() => {
        cancelSource.cancel()
      })

      return this.getClient().request(requestConfig)
        .then(resolve)
        .catch(reject)
    })
  }

  getData (response) {
    if (response && response.data && response.data.data) {
      return response.data.data
    }
    return Promise.reject(new Error('Wrong response'))
  }

  getDataItem (response) {
    if (response && response.data && response.data.data && response.data.data[0]) {
      return response.data.data[0]
    }
    return Promise.reject(new Error('Wrong response'))
  }
}

export default new Api()
